module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/readable-stream@2.3.8/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 273
// module chunks = 0